const DefaultData = {
  APISERVERURL: 'https://b2cclienttravel.azurewebsites.net/api/',
  APILOCALURL: 'http://localhost:5126/api/',
  APIACTIVEURL: 'https://zotraiapi.azurewebsites.net/api/',
  DEFAULTPAYMENTGATEWAYFEE: 2.5,
  DEFAULTCURRENCY: 'INR',
  DEFAULTCOMPANYNAME: 'SAAR DEVELOPERS CODE PRIVATE LIMITED',
  DEFAULTBRANDNAME: 'ZOTRAI',
  USERTYPE: "CUSTOMER",
  DOMESTICFLIGHTFEE: "40",
  INTERNATIONALFLIGHTFEE: "200",
  DOMESTICHOTELBOOKINGFEE: "300",
  INTERNATIONALHOTELBOOKINGFEE: "500",
  BUSBOOKINGFEE: "50",
  PaymentGatewayFee: "2",
  DEFAULTCOMPANYID: "d19eb72e-9995-4380-8e23-6a6e5316e035",
};
export const S3_BASE_URL = 'https://trawtelcdn.s3.eu-north-1.amazonaws.com/';
export default DefaultData;